import angular from 'angular';
import CartService from '../../../../cart/cart.service';
import { AuthService } from '../../../../../components/auth/auth.service';
import { OrderShipmentsComponent } from './order-shipments.component';
export var OrderShipmentsModule = angular
    .module('directives.orderShipments', [])
    .component('orderShipments', OrderShipmentsComponent)
    .service(CartService, 'CartService')
    .service(AuthService, 'Auth')
    .name;
//# sourceMappingURL=order-shipments.module.js.map